import { createContext } from "react";
var RowContext = /*#__PURE__*/createContext({});
export default RowContext;